import { LOADING_SET, LOADING_UNSET } from '@actions/types'

const initialState = {
  isLoading: []
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case LOADING_SET:
    return {
      ...state,
      isLoading: [...state.isLoading, { ...payload }]
    }
  case LOADING_UNSET:
    return {
      ...state,
      isLoading: state.isLoading.filter(item => {
        const { descriptor, type: isLoadingType } = payload
        if (descriptor) {
          return item.type !== isLoadingType && item.descriptor !== descriptor
        }

        return item.type !== isLoadingType
      })
    }
  default:
    return state
  }
}

export default reducer
